import { pages } from 'config';

export const getRouteFromPathName = (pathname) => {
  const page = pages.find((route) => route.pattern.test(pathname));
  return page?.route;
};
